import { ReactElement } from 'react'
import illustration from '../images/Tonno3.jpg'
import StageContent from '../components/StageContent'
import StageTitle from '../components/StageTitle'
import StageText from '../components/StageText'
import StageOptions from '../components/StageOptions'

const options = [
  {
    text: 'Kylän monipuolisuudesta päätellen köydenvetoa sillalla',
    gotoStage: 4
  },
  {
    text: 'Ehkä Tokio seuraavaksi?',
    gotoStage: 0
  },
  {
    text: 'Matkadokumenttien tarkastajat',
    gotoStage: 0
  }
]

interface Props {
  onStageChange: (stage: number) => void
}

const TonnoStage3 = ({ onStageChange }: Props): ReactElement => {
  return (
    <StageContent illustration={illustration}>
      <StageTitle small>Maailmanympärysmatkalla juhannusyössä</StageTitle>
      <StageText>
        Klong! Klong! Sepän pajassa ollaan taas täydessä työn touhussa. Hyllyt ovat tulvillaan mitä mielenkiintoisimpia esineitä, kuten rivissä olevia pieniä tonttuja. Kurkkaat ikkunasta ja näet, että pajan seinälle heijastetaan elokuvaa. ”Hei! Mennään jo!” kuulet innokkaan äänen kutsuvan hieman kauempaa.
      </StageText>
      <StageText>
        ”Tervetuloa Pariisiin ystäväiseni”, nainen hymyilee leveästi ison kuusen luona olevassa puistikossa ja nyökkää näkyvää torppaa kohden. ”Siis tämänkö takia tulimme tänne asti?” kysyt hölmistyneenä ja saat vastaukseksi naurua ja pään pudistuksen. ”Älähän nyt, voimme jatkaa tästä Berliiniin tai vaikka Australiaan. Sitten tanssimaan ja uimaan, mitä ikinä haluammekaan!” No nythän tuo sekosi, ajattelet. ”No jos vaikka ensin tanssimaan ja sitten Australiaan.”
      </StageText>
      <StageText>
        On lämmin juhannusyö ja Kalliojärven tanssilava on aivan täynnä juhlaväkeä. Nauru raikaa ja korot kopsuvat puisella tanssilavalla. Yhtäkkiä musiikki hälvenee ja juhlat pysähtyvät hetkeksi, kun joku polvistuu kumppaninsa eteen. Tuon ikuisuudelta tuntuneen hetken jälkeen musiikki soi entistä riemukkaammin ja kaikki onnittelevat pariskuntaa kihlauksesta. ”Australia odottaa”, kaverisi tökkää sinua käsivarteen ja niinpä lähdette jatkamaan matkaa.
      </StageText>
      <StageText>
        <strong>Mitä uskoisit, että kylässä voi vielä tulla vastaan?</strong>
      </StageText>
      <StageOptions options={options} onSelect={onStageChange} />
    </StageContent>
  )
}

export default TonnoStage3
